const defaultObjetivoForm = {
	id: '',
	familia: null,
	peso: '',
	objetivo: '',
	fecha: null,
	llave: false,
	comerciales: null,
	comercial: null,
}

export default defaultObjetivoForm;
